export default {
	title: "Web3",
	rule: "Regelbeschreibung",
	safe: "Geldsicherheit",
	balance: {
		total: "Gesamtbetrag",
		yesterday: "Gewinn von gestern",
		cumulatively: "Kumulierte Gewinne",
		in: "Einzahlungsbetrag",
		out: "Auszahlungsbetrag",
		available: "Verfügbares Guthaben"
	},
	actions: {
		in: "Einzahlen",
		out: "Auszahlen"
	},
	type: ["Alle", "Einzahlung", "Auszahlung", "Gewinn"],
	TransactionPassword: "Transaktionskennwort",
	Amount: "Betrag",
	date: "Datum"
};
